import * as types from "../actions/types";
import { toast } from "react-toastify";

const initialState = {
    list: [],
    listLoading: false,
    createLoading: false,
    createError: false,
    editLoading: false,
    editError: false,
    deleteLoading: false,
    deleteError: false,
    departments: [],
    departmentsLoading: false,
};

function moderators(state = initialState, action) {
    switch (action.type) {
        // FETCH Coordinators
        case types.COORDINATORS_FETCH_REQUESTED: {
            return Object.assign({}, state, { listLoading: true });
        }
        case types.COORDINATORS_FETCH_SUCCESS: {
            return Object.assign({}, state, {
                listLoading: false,
                list: action.data,
            });
        }
        case types.COORDINATORS_FETCH_FAILURE: {
            return Object.assign({}, state, { listLoading: false, list: [] });
        }
        // ADD Coordinators
        case types.ADD_COORDINATOR_REQUESTED: {
            return Object.assign({}, state, {
                createLoading: true,
                createError: false,
            });
        }
        case types.ADD_COORDINATOR_SUCCESS: {
            toast.success("L'utilisateur a été créé");
            return Object.assign({}, state, {
                createLoading: false,
                list: [...state.list, action.data],
            });
        }
        case types.ADD_COORDINATOR_FAILURE: {
            toast.error("L'utilisateur n'a pas pu être créé");
            return Object.assign({}, state, {
                createLoading: false,
                createError: action.data,
            });
        }
        // EDIT Coordinators
        case types.EDIT_COORDINATOR_REQUESTED: {
            return Object.assign({}, state, {
                editLoading: true,
                editError: false,
            });
        }
        case types.EDIT_COORDINATOR_SUCCESS: {
            toast.success("L'utilisateur a été modifié");
            return Object.assign({}, state, {
                editLoading: false,
                list: state.list.map((item) => (item["@id"] === action.data["@id"] ? action.data : item)),
            });
        }
        case types.EDIT_COORDINATOR_FAILURE: {
            toast.error("L'utilisateur n'a pas pu être modifié");
            return Object.assign({}, state, {
                editLoading: false,
                editError: action.data,
            });
        }
        // REMOVE Coordinators
        case types.REMOVE_COORDINATOR_REQUESTED: {
            return Object.assign({}, state, {
                deleteLoading: true,
                deleteError: false,
            });
        }
        case types.REMOVE_COORDINATOR_SUCCESS: {
            toast.success("L'utilisateur a été supprimé");
            return Object.assign({}, state, {
                deleteLoading: false,
                list: state.list.filter((item) => item["@id"] !== action.data),
            });
        }
        case types.REMOVE_COORDINATOR_FAILURE: {
            toast.error("L'utilisateur n'a pas pu être supprimé");
            return Object.assign({}, state, {
                deleteLoading: false,
                deleteError: action.data,
            });
        }
        // FETCH Coordinators Departments
        case types.COORDINATORS_DEPARTMENTS_FETCH_REQUESTED: {
            return Object.assign({}, state, { departmentsLoading: true });
        }
        case types.COORDINATORS_DEPARTMENTS_FETCH_SUCCESS: {
            return Object.assign({}, state, {
                departmentsLoading: false,
                departments: action.data,
            });
        }
        case types.COORDINATORS_DEPARTMENTS_FETCH_FAILURE: {
            return Object.assign({}, state, {
                departmentsLoading: false,
                departments: [],
            });
        }
        default:
            return state;
    }
}

export default moderators;
